import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalResponseCodes } from '@src/suite/common/components/modal/modal.service';

export interface AlertData {
    title: string;
    message: string;
    detailed: string;
}

@Component({
    selector: 'st-fatal-modal',
    templateUrl: './fatal.html',
    styleUrls: ['../modal/modal.scss'],
    host: {
        class: 'st-fatal',
    },
    encapsulation: ViewEncapsulation.None,
})
export class FatalModalComponent {
    @Input() public title: string = 'Error';
    @Input() public message: any = 'Message';
    @Input() public detailed: string = '';
    @Input() public restart: string = 'Restart';

    constructor(
        public dialogRef: MatDialogRef<FatalModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AlertData
    ) {
        this.title = data.title;
        this.message = data.message;
        this.detailed = data.detailed;
    }

    onRestartClick(): void {
        this.dialogRef.close(ModalResponseCodes.RESTART);
        window.location.reload();
    }
}
